import React from "react";
import { DarkModeSwitch } from "react-toggle-dark-mode";

const Switcher = ({darkSide,toggleDarkMode}) => {
  return (
    <>
      <div className="m-16 flex flex-col items-center">
        <DarkModeSwitch
          style={{opacity:0.6}}
          checked={darkSide}
          onChange={toggleDarkMode}
          size={28}
        />
      </div>
    </>
  );
};

export default Switcher;
